import { init, track, Identify, identify } from '@amplitude/analytics-browser';

import { type VisitorService } from '@/services/visitor';

type EventProps = Record<string, string | number | string[] | number[]>;

export default class AmplitudeService {
  private generalEventProps: EventProps = {};
  private userId: string;
  private deviceId: string | undefined;

  constructor(private readonly visitorService: VisitorService) {
    this.userId = this.visitorService.visitorUUID;
  }

  init() {
    const AMPLITUDE_API_KEY = window.amplitudeApiKey ?? '';

    if (AMPLITUDE_API_KEY) {
      const searchParams = new URLSearchParams(window.location.search);
      const urlUserId = searchParams.get('mp_user_id');
      const urlDeviceId = searchParams.get('udid');

      if (urlUserId) {
        this.userId = urlUserId;

        if (location.pathname.includes('windows')) {
          const identifyEvent = new Identify();
          identifyEvent.set('user_id', urlUserId);
          identify(identifyEvent);
        }
      }

      if (urlDeviceId) {
        this.deviceId = urlDeviceId;
      }

      if (location.pathname.includes('windows')) {
        if (urlDeviceId) {
          this.userId = urlDeviceId;
        }
      }

      init(AMPLITUDE_API_KEY, {
        userId: this.userId,
        deviceId: this.deviceId,
        autocapture: {
          attribution: true,
          pageViews: false,
          sessions: false,
          formInteractions: false,
          fileDownloads: false,
          elementInteractions: false,
          frustrationInteractions: false,
          networkTracking: false,
          webVitals: false,
        },
      });
    }
  }

  setGeneralEventProps(props: EventProps) {
    this.generalEventProps = {
      ...this.generalEventProps,
      ...props,
    };
  }

  sendEvent(eventName: string, props: EventProps = {}) {
    const properties: EventProps = {
      ...this.generalEventProps,
      ...props,
      event_properties__user_id: this.userId,
    };

    if (this.deviceId) {
      properties.event_properties__device_id = this.deviceId;
    }

    track(eventName, properties);
  }
}
